var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessToastTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 14.5238,
    rx: 15,
    ry: 14.5238,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5044 8.86553C24.0642 9.41019 24.0642 10.2933 23.5044 10.8379L13.8994 20.1824C13.3395 20.727 12.4318 20.727 11.872 20.1824L6.49606 14.9523C5.93621 14.4076 5.93621 13.5245 6.49606 12.9799C7.05591 12.4352 7.9636 12.4352 8.52345 12.9799L12.8857 17.2238L21.477 8.86553C22.0368 8.32087 22.9445 8.32087 23.5044 8.86553Z",
    fill: "#77C043"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessToastTick);
export default __webpack_public_path__ + "static/media/success-toast-tick.cdd94d715825f59ef911b3a571a2968d.svg";
export { ForwardRef as ReactComponent };